export default "__VITE_ASSET__Bk8P6m3g__"